import { css } from '@genesislcap/web-core';
import { HIGHLIGHT_AMBER_BG, HIGHLIGHT_AMBER_COLOR } from '../../../../styles';

export const principalAmountModalStyles = css`
  :host {
    display: block;
    pointer-events: none;
    z-index: 10;
  }

  .principal-amount-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    background: #1f2126;
    border: 1px solid #505050;
    border-radius: 4px;
    padding: 10px 14px;
    min-width: 200px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.45);
    pointer-events: auto;
  }

  .principal-amount-label {
    color: #ffffff;
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
  }

  .principal-amount-value {
    color: #ffffff;
    font-size: 13px;
    font-weight: 500;
    text-align: right;
    white-space: nowrap;
  }

  .principal-amount-value--highlighted {
    background-color: ${HIGHLIGHT_AMBER_BG};
    color: ${HIGHLIGHT_AMBER_COLOR};
    padding: 0 7px;
    border-radius: 2px;
    display: inline-block;
    line-height: 2;
  }
`;
